import { Icon } from '@lego/connect-components-react';
import type { MRT_Row } from 'material-react-table';
import type { BaseRowDataForDisplay } from './table-types';

type ExpandButtonProps<T extends BaseRowDataForDisplay> = { row: MRT_Row<T> };

const ExpandButton = <T extends BaseRowDataForDisplay>({
  row,
}: ExpandButtonProps<T>) => {
  return (
    <Icon
      aria-label="expand"
      size="small"
      name="chevron-down"
      onClick={(e) => {
        row.toggleExpanded();
      }}
      style={{
        cursor: 'pointer',
        marginLeft: '4px',
        transform: row.getIsExpanded() ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s ease',
      }}
    />
  );
};
export default ExpandButton;
